import './HeroSection.css';
import tiersHeader from "../images/tiersHeader.svg"

const TIERS = [
  { n: 1, price: 20, range: 'First 300,000 hands' },
  { n: 2, price: 30, range: '300,001 - 600,000' },
  { n: 3, price: 40, range: '600,001 - 900,000' },
  { n: 4, price: 50, range: 'All remaining hands' },
]

const Tiers = () => (
  <section className="tiers-section scroll-fx-up-out-fade scroll-fx-up-in">
    <div className="tiers-header container-fluid text-center">
      <img
        className="img-fluid"
        src={tiersHeader}
        alt="Tiers Section Header Image"
      />
    </div>
    <div className="container">
      <div className="tiers-grid">
        {TIERS.map(tier => (
          <div className="tier-card" key={tier.n}>
            <div className="tier-n">Tier {tier.n}</div>
            <div className="tier-price">{tier.price} ADA</div>
            <div className="tier-range">{tier.range}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Tiers;
